import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateRefundDetailsAction as updateRefundDetails } from '../../../../../services/RefundService/slice';

export const OpenClaimsSwitch: React.FC = () => {
    const dispatch = useAppDispatch();
    const { currentRefund } = useAppSelector(state => state.refund);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(updateRefundDetails({ openClaims: event.target.checked }));
    };

    return (
        <FormControlLabel
            control={
                <Switch
                    checked={currentRefund?.refundDetail?.openClaims || false}
                    onChange={handleChange}
                    size="small"
                />
            }
            label="Open Claims"
        />
    );
};

export default OpenClaimsSwitch;
